import { defineMessages } from 'react-intl';

export default defineMessages({
  newAd: {
    id: 'global_new_ad',
    defaultMessage: 'New',
  },
  viewItem: {
    id: 'global_view_item',
    defaultMessage: 'View item',
  },
  unavailablePrice: {
    id: 'global_wm_unavailable_price',
    defaultMessage: 'On Request',
  },
  sponsoredTag: {
    id: 'global_wm_promoted_ad_tag',
    defaultMessage: 'Sponsored',
  },
  grossYear: {
    id: 'global_trovitAdsJobs_salary_grossYear',
    defaultMessage: 'Gross/per annum',
  },
  itemSeenAt: {
    id: 'global_serp_item_seen_at',
    defaultMessage: 'Seen at',
  },
  more: {
    id: 'global_more',
    defaultMessage: 'More',
  },
});



// WEBPACK FOOTER //
// ./app/common/messages.js